import { useRef, useState } from 'react';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';

import {
  Inbox,
  Person,
  PersonOutline,
  PowerSettingsNew
} from '@mui/icons-material';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'src/store/hook';
import { store } from 'src/store';
import { removeToken } from 'src/store/token/tokenSlice';
import { removeUser } from 'src/store/user/userSlice';
import toast from 'react-hot-toast';
import api from 'src/utils/axios';
import { formatDisplayName } from 'src/utils/formater';
import { useNavigate } from 'react-router-dom';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const userInfo: any = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const logout = () => {
    toast
      .promise(api.post('admin/auth/logout'), {
        loading: 'Sedang logout...',
        success: 'Berhasil logout',
        error: 'Gagal logout'
      })
      .then(() => {
        store.dispatch(removeToken());
        store.dispatch(removeUser());
        window.location.href = '/auth/login';
      })
      .catch(() => {});
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar
          variant="rounded"
          alt={userInfo?.name}
          src={userInfo?.profileImageUrl}
        />
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {formatDisplayName(userInfo?.name)}
            </UserBoxLabel>
            <UserBoxDescription variant="body2">
              {userInfo?.role}
            </UserBoxDescription>
          </UserBoxText>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Box>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar
            variant="rounded"
            alt={userInfo?.name}
            src={userInfo?.profileImageUrl}
          />
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {formatDisplayName(userInfo?.name)}
            </UserBoxLabel>
            <UserBoxDescription variant="body2">
              {userInfo?.role}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {
                navigate('/profile');
                handleClose();
              }}
            >
              <ListItemIcon>
                <Person sx={{ color: '#AB6D34' }} />
              </ListItemIcon>
              <ListItemText primary="Profil" />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={() => logout()}>
            <PowerSettingsNew sx={{ mr: 1 }} />
            Keluar
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
